import ViewBase from "../../../framework/core/mvvm/view_base";
import LanguageManager from "../../../manager/language_manager";
import { BankOperate } from "./clubbank_module";
import GameUtil from "../../../utility/game_util";
import { CountUp } from "../../../lib/countUp";
import Utility from "../../../utility/utility";
import { IUserData } from "../../public/model_data";

const { ccclass, property } = cc._decorator;

@ccclass
export default class ClubBankView extends ViewBase {

    @property(cc.Node)
    operatePanel: cc.Node = null

    @property(cc.Node)
    functionPanel: cc.Node = null

    @property(cc.Node)
    moneyInputPanel: cc.Node = null

    @property(cc.Node)
    tipsPanel: cc.Node = null

    @property(cc.Node)
    recordPanel: cc.Node = null

    @property(cc.Node)
    transferRed: cc.Node = null

    @property([cc.Label])
    passwordInputLabel: cc.Label[] = []

    @property(cc.Label)
    setPasswordLabel: cc.Label = null

    @property([cc.Label])
    moneyInputTipLabel: cc.Label[] = []

    @property(cc.Label)
    tipsPanelLabel: cc.Label = null

    @property(cc.EditBox)
    moneyOperateInputBox: cc.EditBox = null
    @property(cc.Node)
    inputNode: cc.Node = null
    @property(cc.EditBox)
    friendInputBox: cc.EditBox = null

    @property(cc.Node)
    chooseFriend: cc.Node = null

    @property(cc.Node)
    transferBtnNode: cc.Node = null

    @property(cc.Label)
    bankMoneyLabel: cc.Label = null

    @property(cc.Label)
    carryMoneyLabel: cc.Label = null

    @property(cc.Node)
    pageSaveRecord: cc.Node = null

    @property(cc.Node)
    pageTransferRecord: cc.Node = null

    @property(cc.Node)
    transferRecordParent: cc.Node = null
    @property(cc.Node)
    saveRecordParent: cc.Node = null

    @property(cc.Node)
    recordItem: cc.Node = null

    @property([cc.Node])
    recordToggleSave: cc.Node[] = []

    @property([cc.Node])
    recordToggleTransfer: cc.Node[] = []


    @property(cc.Node)
    tipsMaskNode: cc.Node = null

    @property(cc.Button)
    passwordSureBtn: cc.Button = null

    @property(cc.Slider)
    opSlider: cc.Slider = null

    @property(cc.ProgressBar)
    opProgressbar: cc.ProgressBar = null

    @property(cc.Node)
    opButton: cc.Node = null

    @property(cc.Node)
    opBg: cc.Node = null

    @property(cc.Node)
    moneyInputPlayerInfo: cc.Node = null

    @property(cc.Sprite)
    transferAvatar: cc.Sprite = null

    @property(cc.Label)
    transferName: cc.Label = null

    @property(cc.Label)
    transferId: cc.Label = null

    @property(cc.Label)
    transferTotal: cc.Label = null

    recordList
    passwordColor
    passwordInputIndex: number = 0
    recordBankGold: number = 0
    recordCarryGold: number = 0
    onShow() {
        let self = this
        this.moneyInputPanel.opacity = 0
        this.moneyInputPanel.active = true
        this.doScheduleOnce(function () {
            self.moneyInputPanel.active = false
        }, 0.1)

        this.tipsPanel.active = false
        this.recordPanel.active = false
        this.passwordColor = this.passwordInputLabel[0].node.color
        // this.moneyInputAnim(0)
    }

    moduleShow(status) {
        if (status == 0) {
            this.functionPanel.active = false
            this.operatePanel.opacity = 0
            this.operatePanel.runAction(cc.fadeIn(0.2))
        } else if (status == 1) {
            this.functionPanel.opacity = 0
            this.functionPanel.runAction(cc.fadeIn(0.2))
            this.operatePanel.opacity = 0
            this.operatePanel.runAction(cc.fadeTo(0.2, 177))
            this.operatePanel.scale = 0.8
        } else {
            this.functionPanel.active = true
            this.functionPanel.opacity = 0
            this.functionPanel.runAction(cc.fadeIn(0.2))
            this.operatePanel.runAction(cc.fadeTo(0.2, 177))
            this.operatePanel.runAction(cc.scaleTo(0.2, 0.8))
        }
    }
    moneyInputAnim(status) {
        if (status == 0) {
            this.operatePanel.scale = 0.8
            this.operatePanel.opacity = 178
        } else if (status == 1) {  //显示
            this.operatePanel.runAction(cc.fadeTo(0.2, 255))
            this.operatePanel.runAction(cc.scaleTo(0.2, 1))
        } else {  //缩小
            if (this.operatePanel.scale == 1) {
                this.operatePanel.runAction(cc.fadeTo(0.2, 177))
                this.operatePanel.runAction(cc.scaleTo(0.2, 0.8))
            }
        }
    }
    passwordAnim(correct, func?) {
        let self = this
        let changeColorFunc = function (c, delay?) {
            for (let i = 0; i < self.passwordInputLabel.length; i++) {
                if (delay) {
                    self.scheduleOnce(function () {
                        self.passwordInputLabel[i].node.color = c
                        if (i == this.passwordInputLabel.length - 1) {
                            self.scheduleOnce(function () {
                                changeColorFunc(self.passwordColor)
                                if (func) {
                                    func()
                                }
                            }, 0.2)
                        }
                    }, 0.25 * i)
                } else {
                    self.passwordInputLabel[i].node.color = c
                }
            }
        }
        if (correct) {
            changeColorFunc(cc.Color.GREEN, true)
        } else {
            changeColorFunc(cc.Color.RED)
            this.scheduleOnce(function () {
                changeColorFunc(self.passwordColor)
                if (func) {
                    func()
                }
            }, 1)
        }
    }

    bankInit(isSetPw, transfer) {
        this.setPasswordLabel.string = isSetPw ? LanguageManager.t("clubbank_inputpassword") : LanguageManager.t("clubbank_setpassword")
        // this.functionPanel.active = isSetPw
        // this.transferBtnNode.active = transfer
        this.numberInputDeal()
    }
    updateMoney(bank, gold) {
        let self = this
        this.numberLaberAnim(this.recordBankGold, bank, 0.5, function (n) {
            self.bankMoneyLabel.string = Utility.numberFormat(n)//GameUtil.currencyFormatting(n,0)
        })
        this.numberLaberAnim(this.recordCarryGold, gold, 0.5, function (n) {
            self.carryMoneyLabel.string = Utility.numberFormat(n)//GameUtil.currencyFormatting(n,0)
        })
        this.recordBankGold = bank
        this.recordCarryGold = gold
    }
    numberLaberAnim(startValue, endValue, duration, updateCallback, finishCallback?) {
        if (startValue == endValue) {
            updateCallback(endValue)
        } else {
            let countUp = new CountUp(null, endValue, {
                startVal: startValue,
                decimalPlaces: 0,
                duration: duration,
                useEasing: true,
                useGrouping: true,
                smartEasingThreshold: 999,
                smartEasingAmount: 333,
                separator: '',
                decimal: '.',
                prefix: '',
                suffix: ''
            })
            if (!countUp.error) {
                countUp.start(function (n) {
                    let num = parseInt(n)
                    if (startValue < endValue && num >= Math.floor(endValue)) {
                        num = endValue
                    } else if (startValue > endValue && num <= Math.ceil(endValue)) {
                        num = endValue
                    }
                    num = parseFloat(num.toString())
                    updateCallback(num)
                }, finishCallback)
            }
        }
    }

    numberInputDeal(input?) {
        if (input == null || input == "C") {
            for (let i = 0; i < this.passwordInputLabel.length; i++) {
                this.passwordInputLabel[i].string = ""
            }
            this.passwordInputIndex = 0
        } else if (input == "Del") {
            if (this.passwordInputIndex > 0) {
                this.passwordInputIndex -= 1
            }
            this.passwordInputLabel[this.passwordInputIndex].string = ""
        } else {
            if (this.passwordInputIndex < this.passwordInputLabel.length) {
                this.passwordInputLabel[this.passwordInputIndex].string = input
                this.passwordInputIndex += 1
            }
        }
    }
    getPassword() {
        if (this.passwordInputIndex == this.passwordInputLabel.length) {
            let str = ""
            for (let i = 0; i < this.passwordInputLabel.length; i++) {
                str += this.passwordInputLabel[i].string
            }
            return str
        }
        return null
    }

    recordToggle(page) {
        this.recordToggleSave[0].active = page != 0
        this.recordToggleSave[1].active = page == 0
        this.recordToggleTransfer[0].active = page != 1
        this.recordToggleTransfer[1].active = page == 1
        this.pageSaveRecord.active = page == 0
        this.pageTransferRecord.active = page == 1
    }

    showRecord(show?, data?) {
        if (show != undefined) {
            if (!this.recordPanel.active) {
                this.recordPanel.opacity = 0
                this.recordPanel.active = true
                this.recordPanel.runAction(cc.fadeIn(0.2))
            }
        } else {
            let self = this
            this.recordPanel.runAction(cc.sequence([cc.fadeOut(0.2), cc.callFunc(function () {
                self.recordPanel.active = false
            }.bind(self))]))
        }
        if (show == undefined) {
            return
        }
        this.recordToggle(show)
        if (data == undefined) {
            return
        }
        let p = show == 0 ? this.saveRecordParent : this.transferRecordParent
        if (!this.recordList) {
            this.recordList = new Array()
        }
        if (!this.recordList[show]) {
            this.recordList[show] = new Array
        }
        for (let i = 0; i < data.length; i++) {
            let item: cc.Node
            if (i + 1 > this.recordList[show].length) {
                item = this.instantiateNode(this.recordItem, p)
                this.recordList[show].push(item)
            } else {
                if (this.recordList[show][i] != undefined) {
                    item = this.recordList[show][i]
                } else {
                    item = this.instantiateNode(this.recordItem, p)
                    this.recordList[show][i] = item
                }
            }
            this.recordItemDeal(item, show, data[i])
        }
    }

    recordItemDeal(item: cc.Node, recordType, data) {
        let time = item.getChildByName("time").getComponent(cc.Label)
        let event = item.getChildByName("event").getComponent(cc.Label)
        time.string = this.timestampToTime(data.createTime)
        if (recordType == 0) {
            if (data.clubOpType == "balance_deposit") {
                event.string = `${data.nickname} ได้ฟากเงินตรานำเข้าเข้าธนาคาร ${data.coins}`
            } else if (data.clubOpType == "balance_withdraw") {
                event.string = `${data.nickname} ได้ถอน ${data.coins} จากธนาคาร`
            }
        } else {
            event.string = `${data.opUserName} โอนให้ ${data.nickname} ${data.coins}`  //%a โอนให้ %b %c
        }
    }
    timestampToTime(timestamp) {

        var date = new Date(timestamp);//时间戳为10位需*1000，时间戳为13位的话不需乘1000

        var Y = date.getFullYear() + '-';

        var M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-';

        var D = date.getDate() + ' ';

        var h = date.getHours() + ':';

        var m = date.getMinutes() < 10 ? '0' + date.getMinutes() + ':' : date.getMinutes() + ':';

        var s = date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds();

        return Y + M + D + h + m + s;

    }
    instantiateNode(node, parent, name?): cc.Node {
        let obj: cc.Node = cc.instantiate(node);
        obj.parent = parent
        obj.x = 0
        obj.y = 0
        obj.angle = 0
        obj.name = name || "clone"
        obj.active = true
        return obj
    }

    operatePanelDeal(status) {
        this.chooseFriend.active = false
        this.tipsPanelDeal("")
        switch (status) {
            case BankOperate.Null:
                this.moneyInputPanelDeal(false)
                this.numberInputDeal()

                break;
            case BankOperate.Save:
                this.moneyInputPanelDeal(true)
                this.moneyPanelView(0)
                this.moneyInputTipLabel[0].string = LanguageManager.t("clubbank_saveinput")
                this.moneyInputTipLabel[1].string = LanguageManager.t("clubbank_save")
                break;
            case BankOperate.WithDraw:
                this.moneyInputPanelDeal(true)
                this.moneyPanelView(0)
                this.moneyInputTipLabel[0].string = LanguageManager.t("clubbank_withdrawinput")
                this.moneyInputTipLabel[1].string = LanguageManager.t("clubbank_withdraw")
                break;
            case BankOperate.Transfer:
                this.moneyInputPanelDeal(true)
                this.moneyPanelView(2)
                this.moneyInputTipLabel[0].string = LanguageManager.t("clubbank_transferinput")
                this.moneyInputTipLabel[1].string = LanguageManager.t("clubbank_transfer")
                break;
            case BankOperate.FriendId:
                this.moneyInputPanelDeal(true)
                this.moneyPanelView(1)
                this.moneyInputTipLabel[0].string = LanguageManager.t("clubbank_transferfriendinput")
                this.moneyInputTipLabel[1].string = LanguageManager.t("clubbank_transferfriend")
                break;
            case BankOperate.SetPassword:
                this.numberInputDeal()
                break;
        }
    }
    moneyPanelView(op: number) {
        this.moneyOperateInputBox.string = ""
        this.moneyOperateInputBox.node.active = op != 1
        this.friendInputBox.node.active = op == 1
        this.opSlider.node.active = op != 1
        this.moneyInputPlayerInfo.active = op == 2

        this.opBg.height = op == 1 ? 361 : op == 2 ? 694 : 500
        this.opButton.y = op == 1 ? -85 : op == 2 ? -410 : -230
        this.opSlider.node.y = op == 2 ? -270 : -70
        this.inputNode.y = op == 2 ? -156 : 48


    }

    transferInfo(userData: IUserData) {
        this.transferTotal.string = this.bankMoneyLabel.string
        this.transferName.string = userData.name
        this.transferId.string = userData.id.toString()
        this.transferAvatar.spriteFrame = userData.avatarSprite
    }
    moneyInputDeal(num, max) {
        this.moneyOperateInputBox.string = num
        this.opSlider.progress = num / max
        this.opProgressbar.progress = num / max
    }
    moneyInputPanelDeal(show, func?) {
        let self = this
        if (show) {
            this.moneyInputPanel.opacity = 0
            this.moneyInputPanel.active = true
            this.moneyInputPanel.runAction(cc.sequence([cc.fadeIn(0.2), cc.callFunc(function () {
                if (func) { func() }
            }.bind(self))]))
        } else {
            this.moneyInputPanel.runAction(cc.sequence([cc.fadeOut(0.2), cc.callFunc(function () {
                self.moneyInputPanel.active = false
                if (func) { func() }
            }.bind(self))]))
        }
    }
    //0 长显 带蒙板 1长显不带蒙板 
    tipsPanelDeal(str, status?) {
        let self = this
        this.numberInputDeal()
        if (str == "") {
            this.tipsPanel.runAction(cc.sequence([cc.fadeOut(0.2), cc.callFunc(function () {
                self.tipsPanel.active = false
            }.bind(self))]))
        } else {
            if (!this.tipsPanel.active) {
                this.tipsPanel.active = true
                this.tipsPanel.opacity = 0
                this.tipsPanel.runAction(cc.fadeIn(0.2))
            }
            this.tipsMaskNode.active = status == 0
            this.tipsPanelLabel.string = str
        }
    }


    pauseBtnClick(pause) {
        this.passwordSureBtn.enabled = !pause
    }
}
